import React from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/OfficeOnboardingSlice";
import { AppDispatch } from "../../redux/store";

interface OnboardingBannerProps {
  currentStep: number;
  totalSteps: number;
}

const OnboardingBanner: React.FC<OnboardingBannerProps> = ({ currentStep, totalSteps }) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleContinueClick = () => {
    dispatch(openModal());
  };

  // Ensure we show at least step 1 (never show "0 of 5")
  const displayStep = Math.max(1, currentStep);

  return (
    <div className="w-full border border-[#2D375B] rounded-lg bg-[#F9F7F4] px-6 py-4 flex flex-col md:flex-row gap-2 items-center justify-between">
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="#2D375B"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-[#2D375B] text-base font-normal">
            Complete Office Setup. You are on Step <span className="font-bold">{displayStep}</span> of <span className="font-bold">{totalSteps}</span>
            .
          </p>
        </div>
      </div>
      <button
        onClick={handleContinueClick}
        className="bg-docnote-orange hover:bg-orange-600 text-white px-6 py-2 rounded-full font-medium transition-colors duration-200 flex-shrink-0"
      >
        Continue Office Setup
      </button>
    </div>
  );
};

export default OnboardingBanner;
